import AnalyticsApi from '../api/AnalyticsAPI';
import type {StudioCostQuery} from '../models/StudioCosts';

class AnalyticsRepository {
  private analyticsApi = new AnalyticsApi();

  public getAdminAnalytics() {
    return this.analyticsApi.getAdminAnalytics();
  }

  public getLastAccessData(page: number, pageSize: number) {
    return this.analyticsApi.getLastAccessData(page, pageSize);
  }
  public getRecentSignups(page: number, pageSize: number) {
    return this.analyticsApi.getRecentSignups(page, pageSize);
  }

  public getStudioCosts(query: StudioCostQuery) {
    return this.analyticsApi.getStudioCosts(query);
  }
}

export default AnalyticsRepository;
